export class VQUADDATA {

  ID: number;
  VQuad_Timestamp: Date;
  Call_Timestamp: Date;
  VQuad_Location: string;
  VQuad_PhoneID: string;
  GPS_Position: string;
  GPS_Lat: number;
  GPS_Long: number;
  Call_Control_Event: string;
  CallType_Orig: string;
  CallType_Term: string;
  VQuad_CallID: string;
  CC_Condition: string;
  Called_Number: string;

  constructor() {
    this.VQuad_Timestamp = new Date();
    this.Call_Timestamp = new Date();
    this.VQuad_Location = "";
    this.VQuad_PhoneID = "";
    this.GPS_Position = "";
    this.GPS_Lat=0;
    this.GPS_Long = 0;
    this.Call_Control_Event = "";
    this.CallType_Orig = "";
    this.CallType_Term = "";
    this.VQuad_CallID = "";
    this.Call_Control_Event = "";
    this.CC_Condition = "";
    this.Called_Number = "";
  }  
}




